<template>
  <div>
    <label class="text-uppercase text-muted font-weight-bold small">Prebid.JS Integration Code</label>
    <b-alert show>
      Add this entry to the bids object in your prebid.js configuration
    </b-alert>
    <code>
      <b-form-textarea
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        readonly
        class="squared-textarea bg-white" rows="6"
        :value="integrationCode">
      </b-form-textarea>
    </code>
  </div>
</template>

<script>
  export default {
      name: 'IntegrationPrebidJs',
      props: {
          zone: { required: true, type: Object }
      },
      computed: {
          integrationCode () {
              return '{\n' +
              '   bidder: \'smrtb\',\n' +
              '   params: {\n' +
              '     zoneId: \'' + this.zone.id + '\'\n' +
              '   }\n' +
              '}'
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/Integrations/Prebidjs.vue